/**
 * Conversion tracking code — what an advertiser puts on the page where a
 * conversion happens.
 *
 * A port of the old UI's `cpa-defaults.ts`. Unlike that UI it escapes the
 * values, as a brand such as "Levi's" would otherwise break the code.
 */
import { adServerHost } from './creativeTags'

/** A value made safe to sit inside a single-quoted script string. */
const quoted = (value: string) => value.replace(/[\\']/g, '\\$&').replace(/</g, '\\x3C')

export interface ConversionTagOptions {
  /** The network's tag id. */
  networkTagId: string
  /** What the conversion is credited to: a line item id, or a retail product id or brand. */
  adSource: string
  /** A custom event type id; left out for a plain conversion. */
  eventType?: string
}

/** The script version, which loads adn.js and registers the conversion. */
export function conversionScript({
  networkTagId,
  adSource,
  eventType,
}: ConversionTagOptions): string {
  const eventLine = eventType ? `\n    eventType: '${quoted(eventType)}', ` : ''
  return (
    '<script src="https://cdn.adnuntius.com/adn.js" async></script>\n' +
    '<script>\n' +
    'window.adn = window.adn || {}; adn.calls = adn.calls || []; adn.calls.push(function() { \n' +
    `  adn.regConversion({${eventLine}\n` +
    `    network: '${quoted(networkTagId || 'unspecified')}', \n` +
    `    adSource: '${quoted(adSource || 'unspecified')}'\n` +
    '  });\n' +
    '});\n' +
    '</script>'
  )
}

/** The image pixel version, for pages that cannot run scripts. */
export function conversionPixel({
  networkTagId,
  adSource,
  eventType,
}: ConversionTagOptions): string {
  const params = new URLSearchParams()
  if (eventType) params.set('eventType', eventType)
  params.set('network', networkTagId || 'unspecified')
  params.set('adSource', adSource || 'unspecified')
  return `<img src="${adServerHost()}/pixelc.gif?${params}">`
}
